import './index.scss'
import React, { useState } from 'react'
import ProgressBar from 'react-bootstrap/ProgressBar';
import WordPressLogo from '../../assets/softwarestack/wordpress.webp'
import Typo3Logo from '../../assets/softwarestack/typo3.webp'

const CMSQuiz = ({ title, text }) => {
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0)
  const [showResult, setShowResult] = useState(false)
  const [recommendation, setRecommendation] = useState({})
  const [answers, setAnswers] = useState({})

  const questions = [
    {
      question: 'Benötigen Sie eine robuste Mehrsprachigkeitsunterstützung?',
      id: 'mehrsprachigkeit',
      explanation: {
        typo3:
          'TYPO3 unterstützt Mehrsprachigkeit nativ und erleichtert die Verwaltung von Inhalten in mehreren Sprachen.',
        wordpress:
          'WordPress kann Mehrsprachigkeit durch Plugins erreichen, was zusätzlichen Aufwand und mögliche Kompatibilitätsprobleme mit sich bringen kann.'
      }
    },
    {
      question: 'Ist eine detaillierte Rechte- und Workflow-Verwaltung für Sie wichtig?',
      id: 'rechteverwaltung',
      explanation: {
        typo3:
          'TYPO3 bietet eine umfangreiche Rechteverwaltung und Workflow-Management, ideal für Teams mit mehreren Redakteuren und Freigabeprozessen.',
        wordpress:
          'WordPress hat eine einfachere Rechteverwaltung und unterstützt komplexe Workflows nur eingeschränkt.'
      }
    },
    {
      question: 'Legen Sie großen Wert auf Sicherheit und Stabilität?',
      id: 'sicherheit',
      explanation: {
        typo3:
          'TYPO3 ist bekannt für seine hohen Sicherheitsstandards und eignet sich gut für Enterprise-Websites mit hohen Sicherheitsanforderungen.',
        wordpress:
          'WordPress ist weit verbreitet und dadurch häufiger Ziel von Hackerangriffen; regelmäßige Updates und sorgfältige Plugin-Auswahl sind wichtig.'
      }
    },
    {
      question: 'Möchten Sie individuelle Designs ohne Einschränkungen umsetzen?',
      id: 'individuelle_designs',
      explanation: {
        typo3:
          'TYPO3 ermöglicht die Umsetzung individueller, pixelgenauer Designs und bietet hohe Flexibilität für maßgeschneiderte Lösungen.',
        wordpress:
          'WordPress bietet viele vorgefertigte Themes; individuelle Anpassungen können jedoch aufwändiger sein.'
      }
    },
    {
      question: 'Planen Sie eine komplexe Website mit speziellen Funktionen?',
      id: 'komplexe_funktionen',
      explanation: {
        typo3:
          'TYPO3 ist ideal für komplexe Projekte und lässt sich flexibel erweitern; es eignet sich gut für große Unternehmen mit spezifischen Anforderungen.',
        wordpress:
          'WordPress stößt bei sehr komplexen Projekten manchmal an seine Grenzen und ist auf viele Plugins angewiesen.'
      }
    },
    {
      question: 'Ist langfristige Planungssicherheit für Sie wichtig?',
      id: 'planungssicherheit',
      explanation: {
        typo3:
          'TYPO3 bietet Long-Term-Support-Versionen (LTS) mit garantierten Updates und Sicherheitspatches über mehrere Jahre.',
        wordpress:
          'WordPress erfordert häufige Updates; Plugins können nach Updates inkompatibel werden, was zusätzlichen Aufwand bedeuten kann.'
      }
    },
    {
      question: 'Möchten Sie ein System, das von einer großen Community unterstützt wird?',
      id: 'community',
      explanation: {
        wordpress:
          'WordPress hat eine riesige internationale Community mit zahlreichen kostenlosen Ressourcen, Plugins und Themes.',
        typo3:
          'TYPO3 hat eine aktive, aber kleinere Community; Unterstützung und Ressourcen sind vorhanden, aber nicht so umfangreich wie bei WordPress.'
      }
    },
    {
      question: 'Ist die Performance bei hohen Besucherzahlen für Sie entscheidend?',
      id: 'performance',
      explanation: {
        typo3:
          'TYPO3 bietet hohe Performance und Stabilität, auch bei hohem Traffic und umfangreichen Erweiterungen.',
        wordpress:
          'Die Performance von WordPress kann bei vielen installierten Plugins beeinträchtigt werden; sorgfältige Optimierung ist notwendig.'
      }
    },
    {
      question: 'Möchten Sie einen Online-Shop integrieren?',
      id: 'onlineshop',
      explanation: {
        wordpress:
          'WordPress bietet mit WooCommerce eine leistungsfähige E-Commerce-Lösung, ideal für Online-Shops jeder Größe.',
        typo3:
          'TYPO3 kann durch Erweiterungen auch für E-Commerce genutzt werden, jedoch ist die Umsetzung oft komplexer.'
      }
    }
  ]

  const typo3Favored = [
    'mehrsprachigkeit',
    'rechteverwaltung',
    'sicherheit',
    'individuelle_designs',
    'komplexe_funktionen',
    'planungssicherheit',
    'performance'
  ]
  const wordpressFavored = [
    'community',
    'onlineshop'
  ]

  const handleAnswer = (value) => {
    setAnswers({
      ...answers,
      [questions[currentQuestionIndex].id]: value
    })
  }

  const handleNextQuestion = () => {
    if (currentQuestionIndex < questions.length - 1) {
      setCurrentQuestionIndex(currentQuestionIndex + 1)
    } else if (currentQuestionIndex === questions.length - 1) {
      setShowResult(true)
      getRecommendation()
    }
  }

  const handleBackQuestion = () => {
    if (currentQuestionIndex > 0) {
      setCurrentQuestionIndex(currentQuestionIndex - 1)
    }
  }

  const handleBackAnswer = () => {
    setAnswers({
      ...answers,
      [questions[currentQuestionIndex].id]: null
    })
  }

  const handleRestart = () => {
    setCurrentQuestionIndex(0)
    setShowResult(false)
    setAnswers({})
  }

  const getRecommendation = () => {
    let typo3Score = 0
    let wordpressScore = 0

    typo3Favored.forEach((id) => {
      if (answers[id] === 'yes') {
        typo3Score += 1
      } else if (answers[id] === 'no') {
        wordpressScore += 1
      }
    })

    wordpressFavored.forEach((id) => {
      if (answers[id] === 'yes') {
        wordpressScore += 1
      } else if (answers[id] === 'no') {
        typo3Score += 1
      }
    })

    if (typo3Score > wordpressScore) {
      setRecommendation({
        text: <p>Basierend auf Ihren Antworten empfehlen wir <b>TYPO3</b> als CMS für Ihr Projekt.</p>,
        image: Typo3Logo
      });
    } else if (wordpressScore > typo3Score) {
      setRecommendation({
        text: <p>Basierend auf Ihren Antworten empfehlen wir <b>WordPress</b> als CMS für Ihr Projekt.</p>,
        image: WordPressLogo
      });
    } else {
      setRecommendation({
        text: <p>Beide CMS könnten für Ihr Projekt geeignet sein. Wir empfehlen eine individuelle Beratung.</p>
      });
    }
  }

  return (
    <div className='cms-quiz'>
      <div className='container'>
        <h2 className='cms-quiz__title'>{title}</h2>
        <p>{text}</p>

        <ProgressBar className='cms-quiz__progress' key="progressbar" now={showResult ? 100 : (currentQuestionIndex / questions.length) * 100} />

        <div
          key={questions[currentQuestionIndex].id}
          className={`cms-quiz__container`}
        >
          {showResult ? (
            <>
              {Object.keys(answers).length === questions.length && (
                <div className='cms-quiz__result'>
                  <div className='cms-quiz__result-content'>
                    <div className='cms-quiz__image'>
                      {recommendation.image && (
                        <img src={recommendation.image} className='cms-quiz__image' alt='' />
                      )}
                    </div>
                    <div className='cms-quiz__text'>
                      <h3>Unsere Empfehlung</h3>
                      {recommendation.text}
                    </div>
                  </div>
                  <div className='cms-quiz__buttons'>
                    <div></div>
                    <button className='button button--color-black button--size-small' onClick={handleRestart}>Neustarten</button>
                  </div>
                </div>
              )}
            </>
          ) :
            (!answers[questions[currentQuestionIndex].id]) ? (
              <>
                <h4 className='cms-quiz__question'>{questions[currentQuestionIndex].question}</h4>
                <div className='cms-quiz__buttons'>
                  <div className='cms-quiz__buttons-actions'>
                    <button className='button button--color-black button--size-small'
                      onClick={() => handleAnswer('yes')}
                    >
                      Ja
                    </button>
                    <button className='button button--color-black button--size-small'
                      onClick={() => handleAnswer('no')}
                    >
                      Nein
                    </button>
                  </div>

                  {currentQuestionIndex !== 0 && (
                    <button className='cms-quiz__back-button' onClick={handleBackQuestion}>
                      Zurück
                    </button>
                  )}

                </div>
              </>
            ) : (
              <>
                <div className='cms-quiz__answer-content'>
                  <img
                    className='cms-quiz__image'
                    src={
                      (answers[questions[currentQuestionIndex].id] === 'yes' &&
                        (typo3Favored.includes(questions[currentQuestionIndex].id) ? Typo3Logo : WordPressLogo)) ||
                      (answers[questions[currentQuestionIndex].id] === 'no' &&
                        (wordpressFavored.includes(questions[currentQuestionIndex].id) ? Typo3Logo : WordPressLogo))
                    }
                    alt=''
                  />
                  <p className="m-0">
                    {(answers[questions[currentQuestionIndex].id] === 'yes' &&
                      (typo3Favored.includes(questions[currentQuestionIndex].id)
                        ? questions[currentQuestionIndex].explanation.typo3
                        : questions[currentQuestionIndex].explanation.wordpress)) ||
                      (answers[questions[currentQuestionIndex].id] === 'no' &&
                        (wordpressFavored.includes(questions[currentQuestionIndex].id)
                          ? questions[currentQuestionIndex].explanation.typo3
                          : questions[currentQuestionIndex].explanation.wordpress))}
                  </p>
                </div>
                <div className='cms-quiz__answer-buttons'>
                  <button className='button button--color-black button--size-small'
                    onClick={handleNextQuestion}
                  >
                    {currentQuestionIndex === questions.length - 1 ? 'Ergebnis anzeigen' : 'Weiter'}
                  </button>
                  <button className='cms-quiz__back-button' onClick={handleBackAnswer}>
                    Zurück
                  </button>
                </div>
              </>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default CMSQuiz
